<!--
 * @Author: Gaho
 * @Date: 2024-03-05 14:50:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-11 19:53:30
 * @Description: circle历史下注结果
-->
<template>
    <div class="ring-results">
        <div 
            v-for="item in betHistory" 
            :key="item._id" 
            class="ring-results-item"
            :class="formatClass(item.sector)"
        >
            <span class="bar-inner"></span>
            <!-- 历史下注结果 popup -->
            <ResultPopup :data="item"></ResultPopup>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import ResultPopup from '../resultPopup/index.vue';

export default defineComponent({
    name: 'circleResults',
    components: {
        ResultPopup,
    },
    props: {
        historyData: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        // 获取历史下注结果
		betHistory(){
            const { historyDelay } = useJoinStateStore();
            // 路由切换到别的游戏后，还会触发computed-gameHistory，防止这种问题出现
            if (useJoinStateStore().gameOfRoute !== 'circleGame'){
                return;
            }
            if (!this.historyData?.fun?.length){
                return Object.assign({}, historyDelay.fun.slice(0,29))
            }
            return Object.assign({}, this.historyData.fun.slice(0,29))
        }
    },
    methods: {
        /**
         * 根据下注类型设置对应的样式
         * @param sector { string } 下注类型
         */
        formatClass(sector: string){
            let resultClass = '';
            switch(sector){
                case 'gray':
                    resultClass = 'ring-results-itemx2';
                break;
                case 'red':
                    resultClass = 'ring-results-itemx3';
                break;
                case 'green':
                    resultClass = 'ring-results-itemx5';
                break;
                case 'yellow':
                    resultClass = 'ring-results-itemx53';
                break;
                default: 
            }
            return resultClass;
        }
    }
});
</script>

<style lang="scss" scoped>
.ring-results {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 4;
    @media (max-width: 1100px) {
        align-items: flex-start;
        left: 0;
        right: auto;
    }
    .ring-results-item {
        cursor: pointer;
        display: block;
        padding: 4px 0;
        position: relative;
        color: #5b6773;
        &:hover {
            .result-popup {
                opacity: 1;
                visibility: visible;
            }
        }
        @media (max-width: 550px) {
            padding: 3px 0 4px;
        }
        .bar-inner {
            display: block;
            height: 2px;
            background-color: currentColor;
            --bar-width: 21.5px;
            width: var(--bar-width);
            @media (max-width: 990px) {
                --bar-width: 10px;
            }
        }
    }
    .ring-results-itemx3 {
        color: #ed1d49;
        .bar-inner {
            width: calc(var(--bar-width) * 1.3);
        }
    }
    .ring-results-itemx5 {
        color: #1bb83d;
        .bar-inner {
            width: calc(var(--bar-width) * 1.7);
        }
    }
    .ring-results-itemx53 {
        color: #ffb636;
        .bar-inner {
            width: calc(var(--bar-width) * 2);
        }
    }
}
</style>
